export const SESSION_STORAGE_NAMESPACE = 'amica-web';

//session objects set by AEM for quoting
export const SESSION_STORAGE_LOCATION_INFO = 'web.user.loc.info.type.manual';
export const SESSION_STORAGE_POLICY_TYPE = 'web.user.selected.policy.type.obj';

export const SESSION_STORAGE_NAMESPACE_QUOTING = 'amica-web-quoting';
export const GW_SESSION_UUID_KEY = 'GWSessionUUID';
